module.exports = __webpack_public_path__ + "img/647686_23292E_333C44_404B55-256px.64ee0c0e.png";